export default __webpack_public_path__ + "static/media/gallery02.a49bb9a4.webp";